var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import { Dependencies, Layout, Auth } from "~/core/decorator";
import { PageService } from "~/utils/page.service";
import { SortService } from "~/utils/sort.service";
import { Getter, namespace, State } from "vuex-class";
import { CaseAssistService } from "~/services/domain-service/case-assist.service.ts";
import CaseAllot from "~/components/distribution-common/case-allot.vue";
import NumberRange from "~/components/common/number-range.vue";
import { CASE_CHANNEL, MENU_CHANNEL } from "~/config/enum.config";
import GetLabelName from "~/components/labeling-strategy/get-label-name.vue";
var CollectionExecutionModule = namespace("collection-execution");
var AllotModule = namespace("case-allot");
var AssistLegalWaitDistribution = /** @class */ (function (_super) {
    __extends(AssistLegalWaitDistribution, _super);
    function AssistLegalWaitDistribution() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.caseChannel = CASE_CHANNEL.assist_legal;
        _this.searchModel = {
            caseNumber: "",
            batchNumber: "",
            principalId: "",
            personalName: "",
            idCard: "",
            loanDate: [],
            mobileNo: "",
            partnerName: "",
            bankName: "",
            mainDeptName: "",
            currentCollectorRealName: "",
            loanAmount: { min: "", max: "" },
            loanPeriod: { min: "", max: "" },
            overdueAmount: { max: "", min: "" },
            businessAddress: "",
            boardAddress: "",
            plateNum: "",
            collectionType: "",
            flowInTime: [],
            personalCollectionRemainingDays: { min: "", max: "" },
        };
        _this.dataSet = [];
        _this.selectionList = [];
        _this.caseAssistIds = [];
        _this.dialog = {
            ManualDivision: false,
            returnCaseAssist: false
        };
        return _this;
    }
    AssistLegalWaitDistribution.prototype.created = function () {
        this.refreshData();
    };
    Object.defineProperty(AssistLegalWaitDistribution.prototype, "departmentType", {
        //过滤协催来源
        get: function () {
            // 要过滤的字段
            var disabledDepartmentTypes = ["WAIT_DISTRIBUTE", "UNIVERSAL", "OUTER", "STOP", "LAW", "CHEAT", "VERIFIER", "REPAIR", "GRAB_CASE", "RECOVERED"];
            return this.$dict.getDictData('DepartmentType').filter(function (v) { return !disabledDepartmentTypes.includes(v.code); });
        },
        enumerable: false,
        configurable: true
    });
    AssistLegalWaitDistribution.prototype.refreshData = function () {
        var _this = this;
        this.caseAssistService
            .getAllWaitLegalCaseAssist(this.searchModel, this.pageService, this.sortService)
            .subscribe(function (data) {
            _this.dataSet = data;
            _this.selectionList = [];
        });
    };
    /**
     * 手动分案
     */
    AssistLegalWaitDistribution.prototype.manualDivision = function () {
        if (this.selectionList.length === 0) {
            this.$message.info("请选择要分配的案件");
            return;
        }
        var unCollection = this.selectionList.find(function (item) { return item.collectionStatus !== 'INNER_COLLECTING' && item.collectionStatus !== 'OUTER_COLLECTING' && item.collectionStatus !== 'LAW_COLLECTING'; });
        if (unCollection) {
            this.$message.info(unCollection.caseNumber + "案件非催收状态，无法分配");
            return;
        }
        this.updateCaseIds(this.selectionList.map(function (v) { return v.caseId; }));
        var caseAssistIds = this.selectionList.map(function (v) { return v.id; });
        this.updateExtData({ caseAssistIds: caseAssistIds });
        this.dialog.ManualDivision = true;
    };
    AssistLegalWaitDistribution.prototype.returnCaseAssist = function () {
        if (this.selectionList.length === 0) {
            this.$message.info("请选择要回收的案件");
            return;
        }
        this.caseAssistIds = this.selectionList.map(function (v) { return v.id; });
        this.caseAssistService.returnCoUrging(this.caseAssistIds);
        this.dialog.returnCaseAssist = true;
    };
    AssistLegalWaitDistribution.prototype.returnCaseAssistClose = function () {
        this.selectionList = [];
        this.caseAssistIds = [];
        this.dialog.returnCaseAssist = false;
    };
    AssistLegalWaitDistribution.prototype.submitReturnCaseAssist = function () {
        var _this = this;
        this.caseAssistIds = this.selectionList.map(function (v) { return v.id; });
        this.caseAssistService.returnCoUrging({ "ids": this.caseAssistIds }).subscribe(function () {
            _this.$message.success('操作成功！');
            _this.returnCaseAssistClose();
            _this.refreshData();
        });
    };
    /**
     * 获取地区id
     */
    AssistLegalWaitDistribution.prototype.getAreaId = function () {
        this.searchModel.areaId =
            this.searchModel.areaIds.length > 0
                ? this.searchModel.areaIds[this.searchModel.areaIds.length - 1]
                : "";
    };
    /**
     * 进入查看执行页
     */
    AssistLegalWaitDistribution.prototype.openExecutionPage = function (row) {
        this.$router.openCaseDetail(row.caseId, {
            menuChannel: MENU_CHANNEL.Assist_legal_await,
            hiddenCaseList: true,
            hiddenAction: true
        });
    };
    /**
     * 重置numberRange
     */
    AssistLegalWaitDistribution.prototype.follFeedback = function () {
        this.searchModel.overdueAmount = { min: "", max: "" };
        this.searchModel.overdueDays = { min: "", max: "" };
        this.searchModel.caseMoney = { min: "", max: "" };
    };
    __decorate([
        Dependencies(PageService)
    ], AssistLegalWaitDistribution.prototype, "pageService", void 0);
    __decorate([
        Dependencies(SortService)
    ], AssistLegalWaitDistribution.prototype, "sortService", void 0);
    __decorate([
        Dependencies(CaseAssistService)
    ], AssistLegalWaitDistribution.prototype, "caseAssistService", void 0);
    __decorate([
        Getter
    ], AssistLegalWaitDistribution.prototype, "visitDepartmentDataNoRoot", void 0);
    __decorate([
        Getter
    ], AssistLegalWaitDistribution.prototype, "visitDepartmentData", void 0);
    __decorate([
        Getter
    ], AssistLegalWaitDistribution.prototype, "departmentData", void 0);
    __decorate([
        AllotModule.Mutation
    ], AssistLegalWaitDistribution.prototype, "updateCaseIds", void 0);
    __decorate([
        AllotModule.Mutation
    ], AssistLegalWaitDistribution.prototype, "updateExtData", void 0);
    __decorate([
        State
    ], AssistLegalWaitDistribution.prototype, "principalList", void 0);
    AssistLegalWaitDistribution = __decorate([
        Auth(1523),
        Layout("workspace"),
        Component({
            components: {
                GetLabelName: GetLabelName,
                CaseAllot: CaseAllot,
                NumberRange: NumberRange
            }
        })
    ], AssistLegalWaitDistribution);
    return AssistLegalWaitDistribution;
}(Vue));
export default AssistLegalWaitDistribution;
